var React = require('react');

function QuoteOld (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 10.6h6.09L8.04 0H1.95L0 10.6Zm7.96 0h6.09L16 0H9.91L7.96 10.6Z"}));
}

QuoteOld.defaultProps = {"className":"quote-svg","width":"16","height":"11","fill":"none"};

module.exports = QuoteOld;

QuoteOld.default = QuoteOld;
